// import { initCarousel } from './carousels/functions';

import Glide from '@glidejs/glide';

window.addEventListener('DOMContentLoaded', () => {
  const grids = document.querySelectorAll('.wp-block-dmnp-masonry-grid');

  for (const grid of grids) {
    new Modal(grid);
  }
});

class Modal {
  constructor(grid) {
    this.body = document.querySelector('body');

    this.grid = grid;
    this.cells = this.grid.querySelectorAll('.wp-block-dmnp-masonry-grid-cell');
    this.modal = this.grid.querySelector('.modal');
    this.close = this.modal.querySelector('.close');
    this.carousel = this.modal.querySelector('.modal-carousel');
    this.glide = null;

    this.initCarousel();
    this.addOpenEvents();
    this.addCloseEvents();
  }

  addOpenEvents() {
    for (const cell of this.cells) {
      const glideId = cell.dataset.index;
      const index = glideId.slice(1);

      if (index >= 0) {
        cell.addEventListener('click', () => {
          this.openModal(glideId);
        });
      }
    }
  }

  addCloseEvents() {
    this.close.addEventListener('click', this.closeModal.bind(this));
    this.modal.addEventListener('click', (e) => {
      if (e.target.className.includes('modal')) {
        this.closeModal();
      }
    });
  }

  openModal(glideId) {
    this.body.classList.add('modal-open');
    this.modal.setAttribute('aria-expanded', true);
    this.glide.update();
    this.glide.go(glideId);
    this.handleBackButton();
  }

  closeModal() {
    this.body.classList.remove('modal-open');
    this.modal.setAttribute('aria-expanded', false);
  }

  handleBackButton() {
    window.history.pushState('forward', null, '#modal-open');
    window.addEventListener('popstate', () => this.closeModal(), {
      once: true,
    });
  }

  initCarousel() {
    this.glide = new Glide(this.carousel, {
      type: 'carousel',
      autoplay: false,
    }).mount();
  }
}
